import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import Input from '../../../components/form/Input';
import TextArea from '../../../components/form/TextArea';
import Select from '../../../components/form/Select';
import { createAppRelease } from '../../../redux/slices/appReleaseSlice';

export default function CreateAppReleaseForm({ onClose, onSuccess }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    version: '',
    releaseNote: '',
    link: '',
    status: false
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const result = await dispatch(createAppRelease(formData)).unwrap();
      toast.success('App release created successfully!');
      onSuccess && onSuccess(result);
      onClose && onClose();
    } catch (error) {
      toast.error(error?.message || 'Failed to create app release');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <Input
        label="Version"
        name="version"
        value={formData.version}
        onChange={handleInputChange}
        placeholder="e.g., 1.0.0"
        required
      />

      <TextArea
        label="Release Notes"
        name="releaseNote"
        value={formData.releaseNote}
        onChange={handleInputChange}
        placeholder="Detailed release notes"
        rows="4"
        required
      />

      <Input
        label="Download Link"
        name="link"
        value={formData.link}
        onChange={handleInputChange}
        placeholder="https://..."
        type="url"
        required
      />

      <div className="flex items-center space-x-2">
        <input
          type="checkbox"
          id="status"
          name="status"
          checked={formData.status}
          onChange={handleInputChange}
          className="rounded border-gray-300"
        />
        <label htmlFor="status" className="text-sm font-medium text-gray-700">
          Active Status
        </label>
      </div>

      <div className="flex justify-end space-x-3 pt-4">
        <button
          type="button"
          onClick={onClose}
          className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50"
          disabled={loading}
        >
          Cancel
        </button>
        <button
          type="submit"
          className={`px-4 py-2 bg-blue-600 text-white rounded-md text-sm font-medium hover:bg-blue-700 ${
            loading ? 'opacity-50 cursor-not-allowed' : ''
          }`}
          disabled={loading}
        >
          {loading ? 'Creating...' : 'Create Release'}
        </button>
      </div>
    </form>
  );
}
